export const listGroupItem = {
    padding: '0.75rem 0.25rem',
    border: '0px',
    marginTop: '-10px',
    // minHeight: '220px'
};

export const sortbyButtonGroup = {
    height: '30px',
}
export const mainContainer = {
    color: '#003755',
    marginLeft: '-85px',
    width: '100%',
    '@media(max-width: 1023px)': {
        width: '100%',
        marginLeft: 'auto',
    },
    '@media(min-width: 1440px)': {
        marginLeft: '-85px',
        maxWidth: '1440px'
    }
};

export const tagSpanOne = {
    padding: '7px 15px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #003755',
    color: '#003755',
    fontWeight: 100,
    fontSize: '16px',
    // display: 'flex',
    alignItems: 'center'
}

export const tagSpanTwo = {
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginLeft: '10px',
}

export const paraDate = {
    // lineHeight: '20px',
    fontSize: '11px',
    fontWeight: 300
}

export const spinner = {
    '-webkit-animation': 'spin 3s linear infinite',
    '-moz-animation': 'spin 3s linear infinite',
    'animation': 'spin 3s linear infinite',
    margin: '0 auto',
    display: 'block'

}

//Added from existing Design
export const date = {
    fontSize: '.8750em',
    fontWeight: '400',
    lineHeight: '1.275em',
    margin: '0 0 5px',
    color: '#003755'
}
export const imageTextContainer = {
    borderTop: '1px solid #DFEEF4',
    padding: '25px 0',
    width: '90%',
    cursor: 'pointer',
    marginTop: '6px',
    position: 'relative',
    transition: 'box-shadow .2s cubic-bezier(.215,.61,.355,1),transform .2s cubic-bezier(.215,.61,.355,1)',
    '&:hover': {
        boxShadow: '0 10px 40px rgba(0,0,0,.1)',
        transform: 'translateY(-4px)'
    },
    '&:after': {
        height: '4px',
        position: 'absolute',
        display: 'block',
        content: ' ',
        backgroundColor: '#fff',
        width: '100%',
        left: '0',
        bottom: '-4px',
        transition: 'height .2s cubic-bezier(.215,.61,.355,1)'
    }
};

export const imageContainer = {

};
export const thumbnail = {
    maxWidth: '220px',
    height: '110px',
    display: 'block',
    margin: '0 auto',
    width: '100%',
    '@media(min-width:0px) and (max-width:767px)': {
        maxWidth: '100%',
        marginBottom: '10px',
        height: '140px'
    }
};
export const H3 = {
    color: '#003755',
    fontSize: '1.4375em',
    fontWeight: '700'
}
export const textContent = {
    padding: '0 0 0 1.5%'
}
export const textParagraph = {
    color: '#003755',
    fontSize: '	1.0000em',
    fontWeight: '400',
    // lineHeight: '1.125em',
    marginTop: '6px',
    maxHeight: '45px',
    overflow: 'hidden'
}
export const rightArrow = {
    marginLeft: '40%',
    marginTop: '22%',
    '@media(min-width:0px) and (max-width:767px)': {
        float: 'right',
        marginTop: '0',
        marginLeft: '0'
    }
}
export const readMore = {
    display: 'none',
    '@media(min-width:0px) and (max-width:767px)': {
        display: 'block',
        float: 'right',
        color: '#003755',
        fontSize: '1em'
    }
}